export default __webpack_public_path__ + "static/media/cat-illustration.b8bb83f0.svg";